export default __webpack_public_path__ + "static/media/block-slide-6.875cb444.jpg";